export default "__VITE_ASSET__9DK3LPPU__"